import { readCompatibilityPairs } from './compatibility-bundle-fields';
import type { CompatibilityPairRef } from './compatibility-bundle-types';
import type { DuctedBundleSlot } from './ducted-bundle-picks-types';
import { asCombinationId } from './ducted-compare-identity';

const pairMatchesSlot = (
  pair: CompatibilityPairRef,
  slot: DuctedBundleSlot
): boolean => {
  if (!slot.pick || pair.existingSystemUniqueId !== slot.systemUniqueId) {
    return false;
  }
  const { selection } = slot.pick;
  const combinationId = asCombinationId(selection.combination.ID);
  if (pair.compatibilityCombinationId !== null && combinationId !== null) {
    return pair.compatibilityCombinationId === combinationId;
  }
  return pair.cardId !== null && pair.cardId === selection.cardId;
};

export const findComparedBundleForSlots = <T extends object>(
  systems: ReadonlyArray<T>,
  slots: ReadonlyArray<DuctedBundleSlot>
): T | undefined =>
  systems.find((system) => {
    const pairs = readCompatibilityPairs(system);
    return (
      pairs.length === slots.length &&
      slots.every((slot) => pairs.some((pair) => pairMatchesSlot(pair, slot)))
    );
  });

export const ductedBundleRequestKey = (
  slots: ReadonlyArray<DuctedBundleSlot>
): string => slots.map((slot) => slot.pick?.selection.cardId ?? '').join('+');

export const ductedBundleLeadCombinationId = (
  slots: ReadonlyArray<DuctedBundleSlot>
): number | null => {
  const lead = slots.find((slot) => slot.pick !== null)?.pick;
  return lead ? asCombinationId(lead.selection.combination.ID) : null;
};
